import { jwtAuthAxios } from "../../shared/utils/network-utils";
import {
  Access,
  AccessCreateRequest,
  AccessUpdateRequest,
} from "../models/Access";

export const postAccess = async (body: AccessCreateRequest) =>
  await jwtAuthAxios().post<Access>(`/accesses`, body);

export const putAccess = async (accessId: string, body: AccessUpdateRequest) =>
  await jwtAuthAxios().put<Access>(`/accesses/${accessId}`, body);

export const deleteAccess = async (accessId: string) =>
  await jwtAuthAxios().delete<undefined>(`/accesses/${accessId}`);
